<template>
    <div>
        <router-view :info="info" :notifications="notifications"/>
        <error-messages />
    </div>
</template>

<script>
    import NavBar from '~/components/Shared/Partials/NavBar';
    import PageFooter from '~/components/Shared/Partials/Footer';
    import IdleModal from "../components/Shared/UIComponents/IdleModal";
    import UnauthorisedModal from "../components/Shared/UIComponents/UnauthorisedModal";

    export default {
        components: {
            IdleModal,
            NavBar,
            PageFooter,
            UnauthorisedModal
        },
        data() {
            return {
                isIdle: false,
                unauthorised: false,
            };
        },
        props: ['info', 'notifications'],
        onIdle() {
            this.isIdle = true;
        },
        created() {
            this.$eventBus.$on('exiting-window', (exitingWindow) => {
                this.isIdle = !exitingWindow;
            });

            this.$eventBus.$on('unauthorised', (unauthorised) => {
                this.unauthorised = unauthorised;
            });
        }
    }
</script>
